import React, { useState } from 'react';

import { Alert } from 'antd';
import { Formik, Field } from 'formik';
import * as Yup from 'yup';

import { useAddManual, useEditText } from '@hooks/API/UseInvoices';

import { NwCancelButton, NwSaveButton } from '@components/Gui/NwButton';
import NwDrawer from '@components/Gui/NwDrawer';
import { NWTextAreaCharCounter } from '@components/Gui/NwForm/NwFormItems';
import { NwForm, NwFormButtonsBar } from '@components/Gui/NwForm/NwFormWrapper';

const AddManualDrawer = (props) => {
    const { onClose, invoiceID, record } = props;
    const [touchForm, setTouchForm] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const { mutateAsync: onAddManual } = useAddManual();
    const { mutateAsync: onEditText } = useEditText();
    const initialValues = {
        Text: record ? record.Text : '',
    };

    const saveAddManual = async (values, setSubmitting) => {
        setSubmitting(true);
        setErrorMessage(null);
        try {
            if (record) {
                // Edit text
                if (record.Type === 'Text')
                    await onEditText({
                        data: {
                            InvoiceID: invoiceID,
                            RowID: record.index,
                            Text: values.Text,
                        },
                        type: 'Text',
                    });
                else if (record.RowIds.length === 1)
                    await onEditText({
                        data: {
                            InvoiceID: invoiceID,
                            RowID: record.index,
                            Text: values.Text,
                        },
                        type: 'Statement',
                    });
                else
                    await onEditText({
                        data: {
                            InvoiceID: invoiceID,
                            GroupGuid: record.Guid,
                            Text: values.Text,
                        },
                        type: 'Group',
                    });
            } else {
                // Add text
                await onAddManual({
                    data: {
                        InvoiceID: invoiceID,
                        Text: values.Text,
                    },
                });
            }
            onClose();
        } catch (e) {
            const action = record ? 'saving text' : 'adding text line';
            setErrorMessage(`Error ${action}: ${e?.message || 'unknown error'}`);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <NwDrawer
            touchForm={touchForm}
            onTouchForm={setTouchForm}
            onClose={onClose}
            title={record ? 'Change text' : 'Add a text line'}
        >
            <Formik
                initialValues={initialValues}
                onSubmit={(values, { setSubmitting }) => {
                    saveAddManual(values, setSubmitting);
                }}
                validationSchema={Yup.object().shape({
                    Text: Yup.string().required('Content is required'),
                })}
            >
                {({ isSubmitting, values, handleSubmit }) => (
                    <NwForm values={values} onTouchForm={setTouchForm} onFinish={handleSubmit}>
                        <Field
                            component={NWTextAreaCharCounter}
                            label="Description"
                            name="Text"
                            maxLength={200}
                            type="text"
                            value={values.Text}
                        />
                        {errorMessage && <Alert style={{ margin: '1rem 0' }} message={errorMessage} type="error" />}
                        <NwFormButtonsBar
                            left={
                                <NwCancelButton
                                    disabled={isSubmitting}
                                    onClick={() => {
                                        setTouchForm(false);
                                        onClose();
                                    }}
                                />
                            }
                            right={<NwSaveButton htmlType="submit" disabled={isSubmitting} loading={isSubmitting} />}
                        />
                    </NwForm>
                )}
            </Formik>
        </NwDrawer>
    );
};

export default AddManualDrawer;
